export default __webpack_public_path__ + "static/media/TX_Amber_1.1c1b0e67.png";